export default __webpack_public_path__ + "static/media/nothing.653541a8.webp";